import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
const NotFoundPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to login page in 0 seconds
    const timer = setTimeout(() => {
      navigate("/");
    }, 0);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div>
      <h1>404: Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFoundPage;
